import { lazy } from 'react';
import NoBoundLayout from 'Layouts/NoBound/NoBound';

import { isAuthenticatedUser } from './helpers/authWrapper';

const PdfViewer = lazy(() => import('Containers/PdfViewer/PdfViewer'));


const routes = [
  {
    path: '/pdfviewer/:fileID',
    exact: true,
    ContentComponent: isAuthenticatedUser(PdfViewer),
    Layout: NoBoundLayout,
    bodyClass: ''
  }
];

export default routes;
